import { useQuery } from '@tanstack/react-query';
import { useEntity } from '@/hooks/useEntity';
import { getCheckoutCatalogue } from '../api/billing.api';
import { billingKeys } from './billing.keys';

/**
 * The plans this startup can buy, its name, and any subscription it holds
 * (FR-39). Shared by the purchase page, the review step and the free-tier
 * Billing & Info page, so all three read one cached answer.
 *
 * Disabled when there is no acting entity.
 */
export function useCheckoutCatalogue() {
  const entityId = useEntity()?.entityId;

  return useQuery({
    queryKey: billingKeys.catalogue(entityId ?? 'none'),
    queryFn: () => getCheckoutCatalogue(entityId as string),
    enabled: Boolean(entityId),
  });
}
